


































import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';


@Component
export default class AlarmTable extends Vue {
  @Prop({default: () => []}) private data: any;
}
